import clsx from 'clsx';
import styles from '../EpStarter.module.scss';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { useTranslationStore } from '../../../stores/useTranslationStore';
import { EpDropdown } from '../../../components/EpDropdown';
import { showModal } from '../../../components/EpModal';
import { EpModalHelpSupport } from '../../../components/EpModalHelpSupport';
import { EpIconRegularQuestionCircle } from '../../../components/EpIcon/variants/regular/EpIconRegularQuestionCircle/EpIconRegularQuestionCircle';

/**
 * Footer used in EpStarter template
 */

interface IStarterFooterProps {
  template?: 'default' | 'blue';
}

export const StarterFooter = ({
  template = 'default',
}: IStarterFooterProps) => {
  const { translations } = useTranslationStore((state) => state);
  const modalHelpSupportId = 'modal-help-support';
  const footerTemplate = {
    default: styles['footer__help'],
    blue: [styles['footer__help'], styles['footer__help--blue']],
  };

  return (
    <>
      <footer className={styles['footer']}>
        <div id="ep-starter__footer--recaptcha"></div>
        <div className={styles['footer__fixed']}>
          <EpDropdown
            dropdownId="dropdown--help"
            dropdownTriggerElement={
              <span
                id="footer__button--help"
                className={clsx(
                  'footer__button footer__button--help-start',
                  footerTemplate[template],
                )}
              >
                {t(translations['global'], 'Help')}
                <EpIconRegularQuestionCircle iconSize={32} />
              </span>
            }
            dropdownDefaultListItems={[
              {
                buttonId: 'dropdown__button--support',
                buttonText: t(translations['global'], 'Support'),
                buttonLeftIconName: 'SolidHeadphones',
                buttonOnClickFunc: () => showModal(modalHelpSupportId),
              },
              // {
              //   buttonId: 'dropdown__button--knowledge-base',
              //   buttonText: t(translations['global'], 'Knowledge Base'),
              //   buttonLeftIconName: 'SolidBookReader'
              // }
            ]}
          />
        </div>
      </footer>

      <EpModalHelpSupport
        modalId={modalHelpSupportId}
        translations={translations['global']}
      />
    </>
  );
};
